import {Entity} from '@s-ui/domain'

export class TransactionEntity extends Entity {
  /**
   * @constructor
   * @param {String} id
   * @param {String} adId
   * @param {String} sellerId
   * @param {String} buyerId
   * @param {String} vehicleId
   * @param {String} status
   * @param {EntityWallet} sellerWallet
   * @param {EntityWallet} buyerWallet
   * @param {Number} vehiclePrice
   * @param {String} creationDate
   * @param {String} updatedDate
   */
}
